// Overlay + Scroll Nav + Search
(function() {
  // Overlay management
  var overlay = document.getElementById('megaMenuOverlay');
  var menuBar = document.querySelector('.new-megamenu-bar');
  var menuTriggers = document.querySelectorAll('[data-mega-trigger]');

  function positionOverlay() {
    if (!overlay || !menuBar) return;
    var rect = menuBar.getBoundingClientRect();
    overlay.style.top = rect.bottom + 'px';
  }

  var megaDelay = 350; /* hover-intent: require a deliberate pause so just
                          gliding the cursor across the bar doesn't open it. */
  var megaTimers = {};

  function openMega(el) {
    el.classList.add('mega-open');
    positionOverlay();
    overlay.classList.add('active');
  }
  function closeMega(el) {
    el.classList.remove('mega-open');
    var anyOpen = document.querySelector('.mega-open');
    if (!anyOpen) overlay.classList.remove('active');
  }

  if (overlay && menuTriggers.length > 0) {
    menuTriggers.forEach(function(trigger, i) {
      trigger.addEventListener('mouseenter', function() {
        var el = this;
        clearTimeout(megaTimers['close_' + i]);
        megaTimers['open_' + i] = setTimeout(function() { openMega(el); }, megaDelay);
      });
      trigger.addEventListener('mouseleave', function() {
        var el = this;
        clearTimeout(megaTimers['open_' + i]);
        megaTimers['close_' + i] = setTimeout(function() { closeMega(el); }, 150);
      });
    });
    overlay.addEventListener('click', function() {
      document.querySelectorAll('.mega-open').forEach(function(el) { el.classList.remove('mega-open'); });
      this.classList.remove('active');
    });
  }

  // All Categories sidebar switching
  function initSidebarPanel(containerId, dataAttrSidebar, dataAttrPane) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var items = container.querySelectorAll('.more-sidebar-item');
    var panes = container.querySelectorAll('.more-content-pane');
    items.forEach(function(item) {
      item.addEventListener('mouseenter', function() {
        var idx = this.getAttribute(dataAttrSidebar);
        items.forEach(function(s) { s.classList.remove('active'); });
        this.classList.add('active');
        panes.forEach(function(p) { p.classList.remove('active'); });
        var target = container.querySelector('[' + dataAttrPane + '="' + idx + '"]');
        if (target) target.classList.add('active');
      });
    });
  }
  initSidebarPanel('allCatTrigger', 'data-allcat', 'data-allcat-pane');

  // Show overlay on All Categories hover (with delay)
  var allCatWrap = document.getElementById('allCatTrigger');
  var allCatOpenTimer, allCatCloseTimer;
  if (allCatWrap && overlay) {
    allCatWrap.addEventListener('mouseenter', function() {
      clearTimeout(allCatCloseTimer);
      allCatOpenTimer = setTimeout(function() {
        allCatWrap.classList.add('mega-open');
        positionOverlay();
        overlay.classList.add('active');
      }, megaDelay);
    });
    allCatWrap.addEventListener('mouseleave', function() {
      clearTimeout(allCatOpenTimer);
      allCatCloseTimer = setTimeout(function() {
        allCatWrap.classList.remove('mega-open');
        var anyOpen = document.querySelector('.mega-open');
        if (!anyOpen) overlay.classList.remove('active');
      }, 150);
    });
  }

  // Reposition overlay on scroll
  window.addEventListener('scroll', function() { if (overlay && overlay.classList.contains('active')) positionOverlay(); }, {passive:true});

  // === NAV SCROLL ARROWS (using scrollLeft, no transform) ===
  var scrollContainer = document.getElementById('navScrollContainer');
  var arrowLeft = document.getElementById('navArrowLeft');
  var arrowRight = document.getElementById('navArrowRight');

  // RTL note: modern browsers use the "negative" scrollLeft model — at the
  // start (right edge) scrollLeft is 0 and goes NEGATIVE toward the end (left).
  // So in RTL we mirror both the show/hide thresholds and the scroll sign.
  var navRtl = scrollContainer && getComputedStyle(scrollContainer).direction === 'rtl';

  function updateArrows() {
    if (!scrollContainer) return;
    var max = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    if (max <= 0) {
      if (arrowLeft) arrowLeft.style.display = 'none';
      if (arrowRight) arrowRight.style.display = 'none';
      return;
    }
    var pos = scrollContainer.scrollLeft;
    if (navRtl) {
      if (arrowLeft) arrowLeft.style.display = pos < -2 ? 'flex' : 'none';
      if (arrowRight) arrowRight.style.display = pos > -(max - 2) ? 'flex' : 'none';
    } else {
      if (arrowLeft) arrowLeft.style.display = pos > 2 ? 'flex' : 'none';
      if (arrowRight) arrowRight.style.display = pos < max - 2 ? 'flex' : 'none';
    }
  }

  function scrollNav(dir) {
    if (!scrollContainer) return;
    if (navRtl) {
      // Chrome bug: scrollBy({behavior:'smooth'}) with a NEGATIVE delta is a
      // no-op in an RTL container. scrollTo() with an explicit target works AND
      // animates smoothly. (behavior:'smooth' overrides the inline
      // scroll-behavior:auto set for the auto-scroll loop.)
      var target = scrollContainer.scrollLeft + (-dir * 220);
      scrollContainer.scrollTo({ left: target, behavior: 'smooth' });
    } else {
      scrollContainer.scrollBy({ left: dir * 220, behavior: 'smooth' });
    }
  }

  if (arrowLeft) arrowLeft.addEventListener('click', function() { scrollNav(-1); });
  if (arrowRight) arrowRight.addEventListener('click', function() { scrollNav(1); });
  if (scrollContainer) scrollContainer.addEventListener('scroll', updateArrows, {passive:true});

  setTimeout(updateArrows, 100);
  window.addEventListener('resize', updateArrows);

  // === AUTO CONTINUOUS NAV SCROLL (mobile/tablet) ==================
  // Gently auto-scrolls the category strip back and forth so users see
  // there are more categories. Pauses while the user interacts, while a
  // mega-dropdown is open, when the tab is hidden, and honours
  // prefers-reduced-motion. No DOM cloning — keeps the nav + dropdowns intact.
  (function () {
    if (!scrollContainer) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // The container has CSS `scroll-behavior:smooth` (for the arrow buttons).
    // Per CSSOM that also animates direct scrollLeft assignments, which would
    // make our per-frame loop fight itself and stutter. Force instant scrolling
    // here; the arrow handlers pass behavior:'smooth' explicitly so they keep
    // their smooth animation regardless of this.
    scrollContainer.style.scrollBehavior = 'auto';

    var SPEED = 0.42;        // px per frame (~25px/s) — calm, readable
    var END_PAUSE = 1100;    // ms hold at each end before reversing
    var IDLE_RESUME = 3500;  // ms after user interaction before auto-resume
    var dir = 1;
    var holdUntil = 0;       // end-of-track pause
    var userUntil = 0;       // user-interaction pause

    function isMobile()    { return window.innerWidth <= 1024; }
    function canScroll()   { return (scrollContainer.scrollWidth - scrollContainer.clientWidth) > 12; }
    function dropdownOpen(){ return !!document.querySelector('.new-menu-item.mega-open'); }

    function step(now) {
      requestAnimationFrame(step);
      if (!isMobile() || !canScroll() || document.hidden || dropdownOpen()) return;
      if (now < holdUntil || now < userUntil) return;
      var max = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      if (navRtl) {
        // RTL: travel from 0 (start) to -max (end)
        var nextR = scrollContainer.scrollLeft - dir * SPEED;
        if (nextR <= -max)   { nextR = -max; dir = -1; holdUntil = now + END_PAUSE; }
        else if (nextR >= 0) { nextR = 0;    dir = 1;  holdUntil = now + END_PAUSE; }
        scrollContainer.scrollLeft = nextR;
      } else {
        var next = scrollContainer.scrollLeft + dir * SPEED;
        if (next >= max)      { next = max; dir = -1; holdUntil = now + END_PAUSE; }
        else if (next <= 0)   { next = 0;   dir = 1;  holdUntil = now + END_PAUSE; }
        scrollContainer.scrollLeft = next; // instant (scrollBehavior forced to 'auto' above)
      }
      updateArrows();
    }

    function pauseForUser() { userUntil = performance.now() + IDLE_RESUME; }
    ['pointerdown', 'touchstart', 'wheel', 'mousedown'].forEach(function (ev) {
      scrollContainer.addEventListener(ev, pauseForUser, { passive: true });
    });
    if (arrowLeft)  arrowLeft.addEventListener('click', pauseForUser);
    if (arrowRight) arrowRight.addEventListener('click', pauseForUser);

    setTimeout(function () { requestAnimationFrame(step); }, 900);
  })();

  // ── Unified Search: focus-state (trending/recent/popular) + type-state (AJAX results) ──
  var _searchTimeout = null;
  var _currentQuery = '';
  var _trendingCache = null;
  var _popularCache = null;
  var SEARCH_BACKEND = 'https://admin.menahub.com/api/';

  function initDropdownSearch() {
    var input = document.querySelector('[data-search-input-dropdown]');
    var wrapper = document.querySelector('[data-search-wrapper]');
    var dropdown = document.querySelector('[data-dropdown-results]');
    var focusState = document.querySelector('[data-dd-focus]');
    var typeState = document.querySelector('[data-dd-type]');
    var productsContainer = document.querySelector('[data-dropdown-products]');
    var productsWrapper = document.querySelector('[data-products-wrapper]');
    var loadingState = document.querySelector('[data-dropdown-loading]');
    var noResultsState = document.querySelector('[data-dropdown-no-results]');
    var viewAllSection = document.querySelector('[data-dropdown-view-all]');
    var resultsCount = document.querySelector('[data-results-count]');
    var suggestionsList = document.querySelector('[data-suggestions-list]');
    var clearBtn = document.querySelector('[data-clear-search]');

    if (!input || !dropdown) return;

    function escapeHtml(text) {
      var d = document.createElement('div');
      d.textContent = text || '';
      return d.innerHTML;
    }
    function capitalize(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

    // ── Show focus state on click/focus ──
    input.addEventListener('focus', function() { showFocusState(); });

    input.addEventListener('input', function() {
      var query = input.value.trim();
      if (clearBtn) clearBtn.style.display = query.length > 0 ? 'flex' : 'none';
      clearTimeout(_searchTimeout);
      if (query.length < 2) { showFocusState(); return; }
      // Suggestions populated from API results (not hardcoded)
      _searchTimeout = setTimeout(function() { performSearch(query); }, 300);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        input.value = ''; clearBtn.style.display = 'none'; _currentQuery = '';
        showFocusState(); input.focus();
      });
    }

    document.addEventListener('click', function(e) {
      if (!wrapper.contains(e.target)) {
        dropdown.classList.remove('active');
        if (typeState) typeState.classList.remove('visible');
      }
    });
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        dropdown.classList.remove('active');
        if (typeState) typeState.classList.remove('visible');
      }
    });

    // ── Focus State ──
    function showFocusState() {
      dropdown.classList.add('active');
      if (focusState) focusState.style.display = '';
      if (typeState) { typeState.style.display = 'none'; typeState.classList.remove('visible'); }
      loadTrending(); loadRecent(); loadPopularProducts();
    }

    function showTypeState() {
      if (focusState) focusState.style.display = 'none';
      if (typeState) { typeState.style.display = ''; typeState.classList.add('visible'); }
      dropdown.classList.add('active');
    }

    // ── Trending ──
    function loadTrending() {
      var tags = document.querySelector('[data-dd-trending-tags]');
      var sec = document.querySelector('[data-dd-trending]');
      if (!tags || !sec) return;
      if (_trendingCache) { renderTrending(_trendingCache); return; }
      fetch(SEARCH_BACKEND + 'trending_searches.php?limit=8&days=7')
        .then(function(r) { return r.json(); })
        .then(function(d) { _trendingCache = (d.terms || d.keywords || d.data || []).slice(0, 8); renderTrending(_trendingCache); })
        .catch(function() {});
    }
    function renderTrending(keywords) {
      var tags = document.querySelector('[data-dd-trending-tags]');
      var sec = document.querySelector('[data-dd-trending]');
      if (!keywords.length || !tags) return;
      sec.style.display = '';
      tags.textContent = '';
      keywords.forEach(function(kw) {
        var term = typeof kw === 'string' ? kw : (kw.keyword || kw.term || '');
        if (!term) return;
        var a = document.createElement('a');
        a.className = 'dd-tag';
        a.href = '/search?q=' + encodeURIComponent(term);
        a.textContent = term;
        a.addEventListener('click', function(e) {
          e.preventDefault(); input.value = term; input.dispatchEvent(new Event('input')); saveRecent(term);
        });
        tags.appendChild(a);
      });
    }

    // ── Recent ──
    function loadRecent() {
      var tags = document.querySelector('[data-dd-recent-tags]');
      var sec = document.querySelector('[data-dd-recent]');
      if (!tags || !sec) return;
      var recent = [];
      try { recent = JSON.parse(localStorage.getItem('mh_recent_searches') || '[]'); } catch(e) {}
      if (!recent.length) { sec.style.display = 'none'; return; }
      sec.style.display = '';
      tags.textContent = '';
      recent.slice(0, 5).forEach(function(term) {
        var a = document.createElement('a');
        a.className = 'dd-tag recent';
        a.href = '/search?q=' + encodeURIComponent(term);
        a.textContent = term;
        a.addEventListener('click', function(e) {
          e.preventDefault(); input.value = term; input.dispatchEvent(new Event('input'));
        });
        tags.appendChild(a);
      });
    }
    function saveRecent(q) {
      if (!q || q.length < 2 || q.length > 40) return;
      // Reject garbage: repeated single char like "hhhhh" or "aaaa"
      if (/^(.)\1{3,}/.test(q)) return;
      try {
        var r = JSON.parse(localStorage.getItem('mh_recent_searches') || '[]');
        r = r.filter(function(x) { return x.toLowerCase() !== q.toLowerCase(); });
        r.unshift(q);
        localStorage.setItem('mh_recent_searches', JSON.stringify(r.slice(0, 5)));
      } catch(e) {}
    }

    // ── Popular Products ──
    function loadPopularProducts() {
      var grid = document.querySelector('[data-dd-popular-grid]');
      if (!grid) return;
      if (_popularCache) { renderPopular(_popularCache); return; }
      fetch(SEARCH_BACKEND + 'popular_products.php?limit=6')
        .then(function(r) { return r.json(); })
        .then(function(d) { _popularCache = d.products || []; renderPopular(_popularCache); })
        .catch(function() { grid.textContent = ''; });
    }
    function renderPopular(products) {
      var grid = document.querySelector('[data-dd-popular-grid]');
      if (!grid || !products.length) return;
      grid.textContent = '';
      products.forEach(function(p) {
        var a = document.createElement('a');
        a.className = 'dd-popular-card';
        a.href = p.handle ? '/products/' + p.handle : '#';
        if (p.image) {
          var img = document.createElement('img');
          img.src = p.image; img.alt = p.title || ''; img.loading = 'lazy';
          a.appendChild(img);
        }
        var title = document.createElement('div');
        title.className = 'dd-popular-card-title';
        title.textContent = p.title || '';
        a.appendChild(title);
        var price = document.createElement('div');
        price.className = 'dd-popular-card-price';
        price.textContent = 'QAR ' + Number(p.price || 0).toFixed(2);
        a.appendChild(price);
        grid.appendChild(a);
      });
    }

    // ── AJAX Search (products + collections) ──
    function performSearch(query) {
      if (query === _currentQuery) return;
      _currentQuery = query;
      showTypeState();
      loadingState.style.display = 'flex';
      if (productsWrapper) productsWrapper.style.display = 'none';
      noResultsState.style.display = 'none';
      // Use MenaHub's own brand+category+spec-aware engine (the SAME one that
      // powers the full /search page) instead of Shopify's native
      // /search/suggest.json. The native endpoint only token-matches, so
      // "xiaomi humidifier" returned Xiaomi air purifiers + other brands'
      // humidifiers. api/search.php understands brand + category + spec + price.
      fetch('https://admin.menahub.com/api/search.php?q=' + encodeURIComponent(query) + '&limit=8', { credentials: 'omit' })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var items = (data && data.items) || [];
          var products = items.map(function(it) {
            return {
              title: it.title || '',
              url: it.shopify_handle ? '/products/' + it.shopify_handle : ('/search?q=' + encodeURIComponent(query)),
              image: it.image || (it.images && it.images[0]) || '',
              price: it.price
            };
          });
          loadingState.style.display = 'none';

          // This engine returns products, not a collection list — pass none so
          // the suggestions row still shows trending keywords + the direct link.
          renderSuggestions(query, []);

          if (!products.length) {
            noResultsState.style.display = 'block';
            // Hide sidebar when no results — full width "no results"
            var sidebar = typeState ? typeState.querySelector('.dropdown-sidebar') : null;
            if (sidebar) sidebar.style.display = 'none';
          } else {
            var sidebar = typeState ? typeState.querySelector('.dropdown-sidebar') : null;
            if (sidebar) sidebar.style.display = '';
            displayResults(products, query);
          }
          saveRecent(query);
        })
        .catch(function() { loadingState.style.display = 'none'; noResultsState.style.display = 'block'; });
    }

    function renderSuggestions(query, collections) {
      if (!suggestionsList) return;
      suggestionsList.textContent = '';
      var lowerQ = query.toLowerCase();

      // 1. Trending keywords that match the query
      if (_trendingCache && _trendingCache.length) {
        var matched = _trendingCache.filter(function(kw) {
          var term = (typeof kw === 'string' ? kw : (kw.keyword || kw.term || '')).toLowerCase();
          return term.indexOf(lowerQ) !== -1 && term !== lowerQ;
        }).slice(0, 3);
        matched.forEach(function(kw) {
          var term = typeof kw === 'string' ? kw : (kw.keyword || kw.term || '');
          addSuggestionItem(suggestionsList, term, '/search?q=' + encodeURIComponent(term), '🔥');
        });
      }

      // 2. Matching collections as category links
      collections.slice(0, 2).forEach(function(col) {
        addSuggestionItem(suggestionsList, col.title || '', col.url || '/collections/' + (col.handle || ''), '📂');
      });

      // 3. Direct search link for the query
      addSuggestionItem(suggestionsList, 'Search "' + capitalize(query) + '"', '/search?q=' + encodeURIComponent(query), '🔍');
    }

    function addSuggestionItem(list, text, href, icon) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = href;
      // Click fills input and searches
      a.addEventListener('click', function(e) {
        if (icon === '🔥' || icon === '🔍') {
          e.preventDefault();
          input.value = text.replace(/^Search "/, '').replace(/"$/, '');
          input.dispatchEvent(new Event('input'));
        }
      });
      var span = document.createElement('span');
      span.textContent = icon + ' ';
      span.style.cssText = 'font-size:11px;margin-right:2px;';
      a.appendChild(span);
      a.appendChild(document.createTextNode(text));
      li.appendChild(a);
      list.appendChild(li);
    }

    function displayResults(products, query) {
      productsContainer.textContent = '';
      products.forEach(function(product) {
        var a = document.createElement('a');
        a.className = 'dropdown-product-item';
        a.href = product.url;
        var imgDiv = document.createElement('div');
        imgDiv.className = 'dropdown-product-image';
        var imgUrl = product.image || product.featured_image || '';
        if (imgUrl) {
          var img = document.createElement('img');
          img.src = imgUrl; img.alt = product.title || ''; img.loading = 'lazy';
          imgDiv.appendChild(img);
        }
        a.appendChild(imgDiv);
        var info = document.createElement('div');
        info.className = 'dropdown-product-info';
        var h4 = document.createElement('h4');
        h4.className = 'dropdown-product-title';
        h4.textContent = product.title || '';
        info.appendChild(h4);
        if (product.price) {
          var pr = document.createElement('span');
          pr.style.cssText = 'color:#e28534;font-weight:700;font-size:13px;';
          // Shopify's /search/suggest.json returns price as a formatted
          // major-unit decimal string like "529.00", NOT cents. Do NOT
          // divide by 100 — that's the /products.json contract, not this
          // endpoint's. The previous /100 made every price look ÷100.
          pr.textContent = 'QAR ' + parseFloat(product.price).toFixed(2);
          info.appendChild(pr);
        }
        a.appendChild(info);
        productsContainer.appendChild(a);
      });

      if (productsWrapper) productsWrapper.style.display = 'block';
      if (resultsCount) resultsCount.textContent = products.length + ' found';
      if (viewAllSection) {
        viewAllSection.style.display = products.length >= 4 ? 'block' : 'none';
        var link = document.querySelector('[data-view-all-link]');
        if (link) link.href = '/search?q=' + encodeURIComponent(query);
      }
    }

    // Log search on submit
    var form = document.querySelector('[data-search-form]');
    if (form) form.addEventListener('submit', function() {
      var q = input.value.trim();
      if (q.length >= 2) saveRecent(q);
    });

    // Pre-fetch trending on init so it's available when user types
    loadTrending();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDropdownSearch);
  } else {
    initDropdownSearch();
  }
})();

/* === Mega menu brand logos from brands.json === */
(function(){
  var brandItems = document.querySelectorAll('.mega-brand-item[data-brand]');
  if (!brandItems.length) return;
  fetch(window.MH_BRANDS_JSON_URL)
    .then(function(r){ return r.json(); })
    .then(function(brands){
      var map = {};
      brands.forEach(function(b){ map[b.name.toUpperCase().trim()] = b; });
      brandItems.forEach(function(el){
        var key = (el.dataset.brand || '').toUpperCase().trim();
        var brand = map[key];
        if (brand && brand.logo) {
          el.innerHTML = '<img src="' + brand.logo + '" alt="' + (brand.name || '') + '" loading="lazy" style="max-height:30px;max-width:80px;object-fit:contain">';
          if (brand.url) el.href = brand.url;
        }
      });
    })
    .catch(function(){});
})();

// Mobile search toggle + language disclosure toggle.
// Both gated to user gestures so they only fire on the intended icon.
(function () {
  // ── Mobile search trigger ──────────────────────────────────────
  var trigger  = document.getElementById('mh-mobile-search-trigger');
  var panel    = document.getElementById('mh-mobile-search-panel');
  var backdrop = document.getElementById('mh-mobile-search-backdrop');
  var closeBtn = document.getElementById('mh-mobile-search-close');

  // Both the panel and its backdrop are emitted inside .top_logo_area,
  // which is display:none on mobile. Even with position:fixed the panel
  // is removed from the render tree because a display:none ancestor
  // collapses the entire subtree. Solution: hoist both to <body> on
  // first open so they escape the hidden ancestor. Idempotent.
  function ensureHoisted() {
    if (panel && panel.parentNode !== document.body) document.body.appendChild(panel);
    if (backdrop && backdrop.parentNode !== document.body) document.body.appendChild(backdrop);
  }

  function openSearch() {
    if (!panel) return;
    ensureHoisted();
    panel.classList.add('mh-mobile-open');
    if (backdrop) backdrop.classList.add('is-active');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var input = panel.querySelector('[data-search-input-dropdown]');
    if (input) setTimeout(function () { input.focus(); }, 80);
    document.body.style.overflow = 'hidden';
  }
  function closeSearch() {
    if (!panel) return;
    panel.classList.remove('mh-mobile-open');
    if (backdrop) backdrop.classList.remove('is-active');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (trigger) trigger.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    openSearch();
  });
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (backdrop) backdrop.addEventListener('click', closeSearch);

  // Delegate: mobile-header.liquid renders its own .search-active link
  // (from the search-bar snippet) as the visible mobile search icon —
  // that's a separate element from #mh-mobile-search-trigger above and
  // was left un-wired, so tapping it did nothing (href="#" → no-op).
  // Capture phase so we beat any legacy handlers (ajax-search-bar.liquid
  // hijacks the same selector on some pages). Delegated so late-rendered
  // markup still works.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest &&
            e.target.closest('.mobile-header-search .search-active, .mobile-header-search .header-search a');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    openSearch();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel && panel.classList.contains('mh-mobile-open')) closeSearch();
  });

  // ── Language disclosure ────────────────────────────────────────
  // The Shopify <localization-form> custom element handles toggling
  // when its JS loads, but on this theme it doesn't always wire up.
  // Adding a defensive click handler so the language icon ALWAYS
  // toggles the dropdown — independent of the disclosure script.
  // Capture-phase, document-level handler: intercept language icon/option taps
  // BEFORE any other handler. A global search-overlay opener also matches the
  // icon's `.header-search` class, which on MOBILE made tapping the language
  // icon open SEARCH instead. Capturing + stopImmediatePropagation guarantees
  // the tap always toggles/switches language. Works for every .setting-wrap
  // .language (desktop + the mobile header copy).
  function mhCloseAllLang() {
    document.querySelectorAll('.setting-wrap.language.is-open').forEach(function (o) {
      o.classList.remove('is-open');
      var b = o.querySelector('.disclosure__button'); if (b) b.setAttribute('aria-expanded', 'false');
    });
    mhLangBackdrop(false);
  }
  function mhLangBackdrop(show, wrap) {
    var bd = document.getElementById('mh-lang-backdrop');
    if (show && wrap) {
      if (!bd) {
        bd = document.createElement('div');
        bd.id = 'mh-lang-backdrop';
        bd.addEventListener('click', mhCloseAllLang);
      }
      // Append INSIDE the open switcher so the backdrop shares the list's
      // stacking context (the fixed header). A body-level backdrop would paint
      // above the list and swallow the option taps.
      wrap.appendChild(bd);
      bd.style.display = 'block';
    } else if (bd) { bd.style.display = 'none'; }
  }
  // Full-screen dim + centered spinner shown while the locale switch reloads the
  // page (~1-2s). It lives until the new page replaces the DOM.
  function mhShowLangLoader() {
    if (document.getElementById('mh-lang-loader')) return;
    if (!document.getElementById('mh-lang-loader-kf')) {
      var kf = document.createElement('style');
      kf.id = 'mh-lang-loader-kf';
      kf.textContent = '@keyframes mhLangSpin{to{transform:rotate(360deg)}}';
      document.head.appendChild(kf);
    }
    var ov = document.createElement('div');
    ov.id = 'mh-lang-loader';
    ov.style.cssText = 'position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;background:rgba(15,23,42,0.55);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);';
    var sp = document.createElement('div');
    sp.style.cssText = 'width:48px;height:48px;border-radius:50%;border:4px solid rgba(255,255,255,0.30);border-top-color:#E28534;animation:mhLangSpin 0.75s linear infinite;';
    ov.appendChild(sp);
    document.body.appendChild(ov);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.setting-wrap.language .disclosure__button');
    if (btn) {
      e.preventDefault(); e.stopImmediatePropagation();
      var w = btn.closest('.setting-wrap.language');
      var open = !w.classList.contains('is-open');
      document.querySelectorAll('.setting-wrap.language.is-open').forEach(function (o) { if (o !== w) o.classList.remove('is-open'); });
      w.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      // Dim backdrop behind the centered popup (appended inside w) — all sizes.
      mhLangBackdrop(open, w);
      return;
    }
    var opt = t.closest('.setting-wrap.language .disclosure__item a[data-value]');
    if (opt) {
      e.preventDefault(); e.stopImmediatePropagation();
      var w2 = opt.closest('.setting-wrap.language');
      var input = w2.querySelector('input[name="language_code"]');
      var form = w2.querySelector('form');
      // Hide the popup immediately, then show a dim + centered spinner that stays
      // until the locale switch finishes reloading the page (~1-2s).
      mhCloseAllLang();
      mhShowLangLoader();
      if (input && form) { input.value = opt.getAttribute('data-value'); form.submit(); }
      return;
    }
    if (!t.closest('.setting-wrap.language')) mhCloseAllLang();
  }, true);
})();

// ── Animated search placeholder (noon-style) ──────────────────────────
// Typewriter that cycles  Search for "<keyword>"  across the desktop + mobile
// search inputs. Pauses while the user is typing and when the tab is hidden.
(function () {
  var inputs = Array.prototype.slice.call(
    document.querySelectorAll('input[data-search-input-dropdown]')
  );
  if (!inputs.length) return;
  var __isAr = (document.documentElement.lang || '').indexOf('ar') === 0;
  var words = __isAr ? [
    'آيفون 18 برو', 'آيفون 18', 'آيفون 17 برو ماكس', 'مكيف هواء', 'عطور', 'ماكينة قهوة',
    'تلفزيون ذكي', 'لابتوب', 'مستلزمات أطفال', 'مكنسة كهربائية', 'سماعات',
    'مقلاة هوائية', 'جهاز ألعاب', 'ساعة ذكية'
  ] : [
    'iPhone 18 Pro', 'iPhone 18', 'iPhone 17 Pro Max', 'Air Conditioner', 'Perfumes', 'Coffee Machine',
    'Smart TV', 'Laptops', 'Baby Products', 'Vacuum Cleaner', 'Headphones',
    'Air Fryer', 'Gaming Console', 'Smart Watch'
  ];
  var PREFIX = __isAr ? 'ابحث عن ' : 'Search for ';
  var wi = 0, ci = 0, deleting = false, t = null;

  function setPH(s) {
    inputs.forEach(function (el) { if (!el.value) el.placeholder = s; });
  }
  function step() {
    // While the user is typing, the placeholder is hidden anyway — idle-poll.
    if (inputs.some(function (el) { return el.value; })) { t = setTimeout(step, 800); return; }
    var w = words[wi];
    if (!deleting) {
      ci++; setPH(PREFIX + '"' + w.slice(0, ci) + '"');
      if (ci >= w.length) { deleting = true; t = setTimeout(step, 1600); return; }
      t = setTimeout(step, 75);
    } else {
      ci--; setPH(PREFIX + '"' + w.slice(0, ci) + '"');
      if (ci <= 0) { deleting = false; wi = (wi + 1) % words.length; t = setTimeout(step, 350); return; }
      t = setTimeout(step, 35);
    }
  }
  step();
  document.addEventListener('visibilitychange', function () {
    clearTimeout(t); if (!document.hidden) step();
  });
})();
